import React, { useState } from 'react';
import { T, TopNav, Footer, BandBadge, MonoLabel, Card, Btn } from './ui';

export function ResultsScreen({ branding, results, onBack, isTeacher, onSave }) {
  const [list, setList]   = useState(results);
  const [form, setForm]   = useState({ name:'', score:'', date:'', note:'' });
  const [adding, setAdding] = useState(false);

  function add() {
    if (!form.name.trim() || !form.score.trim()) return;
    const updated = [...list, { id:Date.now(), ...form }];
    setList(updated); onSave && onSave(updated); setForm({ name:'', score:'', date:'', note:'' }); setAdding(false);
  }
  function remove(id) {
    const updated = list.filter(r=>r.id!==id);
    setList(updated); onSave && onSave(updated);
  }

  return (
    <div style={{ minHeight:'100vh', background:'#f0f4f8', display:'flex', flexDirection:'column' }}>
      <TopNav branding={branding} onBack={onBack} backLabel="Home"/>
      <div style={{ maxWidth:900, margin:'0 auto', padding:'24px 18px', flex:1, width:'100%' }}>
        <MonoLabel color={T.gold} style={{ marginBottom:6 }}>Results Gallery</MonoLabel>
        <h1 style={{ fontSize:26, marginBottom:6 }}>Candidate Results</h1>
        <p style={{ fontSize:13, color:'#5a6a88', marginBottom:20, lineHeight:1.6 }}>
          Real results from candidates who achieved their target IELTS scores.
        </p>

        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(220px,1fr))', gap:12, marginBottom:24 }}>
          {list.map(r=>(
            <Card key={r.id} style={{ textAlign:'center', position:'relative' }}>
              <div style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:28, fontWeight:700, color:T.gold, lineHeight:1, marginBottom:6 }}>{r.score}</div>
              <div style={{ fontSize:14, fontWeight:600, marginBottom:3 }}>{r.name}</div>
              <div style={{ fontSize:11, color:'#5a6a88', marginBottom:r.note?8:0 }}>{r.date}</div>
              {r.note && <div style={{ fontSize:12, color:'#5a6a88', lineHeight:1.55, fontStyle:'italic', paddingTop:8, borderTop:`1px solid ${T.border}` }}>{r.note}</div>}
              {isTeacher && <button onClick={()=>remove(r.id)} style={{ position:'absolute', top:8, right:8, background:'none', border:'none', color:T.red, cursor:'pointer', fontSize:12, opacity:.6 }}>✕</button>}
            </Card>
          ))}
        </div>

        {isTeacher && (
          adding ? (
            <Card>
              <div style={{ fontSize:14, fontWeight:600, color:T.gold, marginBottom:12 }}>Add New Result</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:10 }}>
                {[['Candidate Name *','name'],['Score (e.g. Band 7.5) *','score'],['Date (e.g. March 2025)','date'],['Note (optional)','note']].map(([pl,k])=>(
                  <input key={k} value={form[k]} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))} placeholder={pl}
                    style={{ padding:'8px 11px', border:'1px solid #dde3ed', borderRadius:7, background:'#f7f9fc', color:'#1a2233', fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", outline:'none' }}/>
                ))}
              </div>
              <div style={{ display:'flex', gap:8 }}>
                <Btn onClick={add} variant="primary" style={{ flex:1 }}>Save Result</Btn>
                <Btn onClick={()=>setAdding(false)}>Cancel</Btn>
              </div>
            </Card>
          ) : (
            <Btn onClick={()=>setAdding(true)} variant="primary">+ Add Result</Btn>
          )
        )}
      </div>
      <Footer branding={branding}/>
    </div>
  );
}

export function EssaysScreen({ branding, essays, onBack, isTeacher, onSave }) {
  const [list, setList]   = useState(essays);
  const [adding, setAdding] = useState(false);
  const [form, setForm]   = useState({ title:'', author:'', score:'', type:'model', essayType:'discuss', text:'' });
  const [expanded, setExpanded] = useState(null);

  function add() {
    if (!form.title.trim() || !form.text.trim()) return;
    const updated = [...list, { id:Date.now(), date:new Date().getFullYear().toString(), ...form }];
    setList(updated); onSave && onSave(updated); setForm({ title:'', author:'', score:'', type:'model', essayType:'discuss', text:'' }); setAdding(false);
  }
  function remove(id) {
    const updated = list.filter(e=>e.id!==id);
    setList(updated); onSave && onSave(updated);
  }

  return (
    <div style={{ minHeight:'100vh', background:'#f0f4f8', display:'flex', flexDirection:'column' }}>
      <TopNav branding={branding} onBack={onBack} backLabel="Home"/>
      <div style={{ maxWidth:900, margin:'0 auto', padding:'24px 18px', flex:1, width:'100%' }}>
        <MonoLabel color={T.gold} style={{ marginBottom:6 }}>Essay Library</MonoLabel>
        <h1 style={{ fontSize:26, marginBottom:6 }}>Published Essays</h1>
        <p style={{ fontSize:13, color:'#5a6a88', marginBottom:20, lineHeight:1.6 }}>
          Model essays by {branding?.tagline?.replace('with ','')||'Mr. Ahmed Salem'} and high-scoring candidate essays for reference.
        </p>

        {list.map(e=>{
          const isModel = e.type==='model';
          const accent  = isModel?T.blue:T.green;
          const isOpen  = expanded===e.id;
          return (
            <div key={e.id} style={{ background:'#ffffff', border:'1px solid #e2e6ed', borderLeft:`3px solid ${accent}`, borderRadius:10, overflow:'hidden', marginBottom:14 }}>
              <div style={{ padding:'12px 15px', display:'flex', justifyContent:'space-between', alignItems:'flex-start', flexWrap:'wrap', gap:8 }}>
                <div>
                  <div style={{ fontSize:14, fontWeight:600, marginBottom:3 }}>{e.title}</div>
                  <div style={{ fontSize:11.5, color:'#5a6a88' }}>{e.author} · {e.date}</div>
                </div>
                <div style={{ display:'flex', gap:8, alignItems:'center', flexShrink:0 }}>
                  <span style={{ fontFamily:"'JetBrains Mono',monospace", fontSize:10, background:isModel?'rgba(80,144,216,.15)':'rgba(72,168,112,.15)', color:isModel?T.blue:T.green, padding:'2px 8px', borderRadius:100 }}>
                    {isModel?'Model essay':'Candidate essay'}
                  </span>
                  <BandBadge band={e.score}/>
                  {isTeacher && <button onClick={()=>remove(e.id)} style={{ background:'none', border:'none', color:T.red, cursor:'pointer', fontSize:12, opacity:.6 }}>✕</button>}
                  <button onClick={()=>setExpanded(isOpen?null:e.id)}
                    style={{ background:'none', border:'1px solid #dde3ed', color:'#5a6a88', padding:'4px 10px', borderRadius:6, fontSize:12, cursor:'pointer' }}>
                    {isOpen?'Hide':'Read'}
                  </button>
                </div>
              </div>
              {isOpen && (
                <div style={{ padding:'14px 17px', borderTop:`1px solid ${T.border}` }}>
                  {e.text.split('\n\n').map((para,i)=>(
                    <p key={i} style={{ fontSize:13.5, lineHeight:1.9, color:'#1a2233', marginBottom:12 }}>{para}</p>
                  ))}
                </div>
              )}
            </div>
          );
        })}

        {isTeacher && (
          adding ? (
            <Card>
              <div style={{ fontSize:14, fontWeight:600, color:T.gold, marginBottom:12 }}>Add Essay</div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:8 }}>
                {[['Title *','title'],['Author','author'],['Score (e.g. Band 7.5)','score']].map(([pl,k])=>(
                  <input key={k} value={form[k]} onChange={e=>setForm(f=>({...f,[k]:e.target.value}))} placeholder={pl}
                    style={{ padding:'8px 11px', border:'1px solid #dde3ed', borderRadius:7, background:'#f7f9fc', color:'#1a2233', fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", outline:'none' }}/>
                ))}
                <select value={form.type} onChange={e=>setForm(f=>({...f,type:e.target.value}))}
                  style={{ padding:'8px 11px', border:'1px solid #dde3ed', borderRadius:7, background:'#f7f9fc', color:'#1a2233', fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", outline:'none' }}>
                  <option value="model">Model essay</option>
                  <option value="candidate">Candidate essay</option>
                </select>
              </div>
              <textarea value={form.text} onChange={e=>setForm(f=>({...f,text:e.target.value}))} placeholder="Paste the full essay text here. Separate paragraphs with a blank line." rows={8}
                style={{ width:'100%', padding:'9px 12px', border:'1px solid #dde3ed', borderRadius:7, background:'#f7f9fc', color:'#1a2233', fontSize:13, fontFamily:"'Plus Jakarta Sans',sans-serif", outline:'none', resize:'vertical', lineHeight:1.7, marginBottom:10 }}/>
              <div style={{ display:'flex', gap:8 }}>
                <Btn onClick={add} variant="primary" style={{ flex:1 }}>Save Essay</Btn>
                <Btn onClick={()=>setAdding(false)}>Cancel</Btn>
              </div>
            </Card>
          ) : (
            <Btn onClick={()=>setAdding(true)} variant="primary">+ Add Essay</Btn>
          )
        )}
      </div>
      <Footer branding={branding}/>
    </div>
  );
}
